/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'settings': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<defs/><path pid="0" id="settings" class="cls-1" d="M42 1037a3 3 0 1 0-2.815-4H25v2h14.185a3 3 0 0 0 2.815 2zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-10 4a3 3 0 0 0-2.815 2H25v2h4.185a2.982 2.982 0 0 0 5.631 0H45v-2H34.815a3 3 0 0 0-2.815-2zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm10 2a3 3 0 0 0-2.815 2H25v2h14.185a2.995 2.995 0 1 0 2.815-4zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" transform="translate(-25 -1031)"/>'
  }
})
